import { Dict } from "./dict";
import { Translates } from "./i18n";

// export enum MachineTypes {
//     ArticulatingBoomLift = "Articulating Boom Lift",
//     ScissorLift = "Scissor Lift",
//     TelescopicBoomLift = "Telescopic Boom Lift",
//     VerticalMastLift = "Vertical Mast Lift",
//     Forklift= "Forklift",
//     Other= "Other"
// }

// export class MachineTypesRepository {

//     constructor() {}

//     dict(translates: Translates): Dict[] {
//         return (Object.keys(MachineTypes) as (keyof typeof MachineTypes)[]).map((key) => ({
//             id: MachineTypes[key],
//             label: translates.for(`${MachineTypes[key]}`)
//         }))
//     }

// }

import React, { useState } from "react";


interface MachineTypesCategory {
    // id: number;
    name: string;
    items: string[];
}


const machineTypesCategories: MachineTypesCategory[] = [{
    name: "forklifts",
    items: [
        "counterbalance_truck",
        "reach_truck",
        "side_loader",
        "four_way_truck",
        "rough_terrain_truck",
        "double_stacker"
    ]
}, {
    name: "pallet_trucks",
    items: [
        "hand_pallet_truck",
        "electric_pallet_truck",
        "pallet_stacker",
        "pallet_rider",
        "walkie_stacker"
    ]
}, {
    name: "mobile_platforms",
    items: [
        "scissor_lift",
        "vertical_mast_lift",
        "telescopic_boom_lift",
        "articulated_boom_lift",
        "truck_mounted_platform",
        "spider_lift"
    ]
}, {
    name: "cranes",
    items: [
        "mobile_crane",
        "hds",
        "mini_crane",
        "gantry_crane",
        "hoist"
    ]
}, {
    name: "other_utb",
    items: [
        "wire_puller",
        "vacuum_manipulator",
        "reach_stacker",
        "telehandler",
        "amr_agv"
    ]
}, {
    name: "cars",
    items: [
        "passenger_car",
        "delivery_vehicle",
        "truck_lorry",
        "other_vehicle"
    ]
}];

export function getCategoryNameByItem(item: string): string | undefined {
  for (const category of machineTypesCategories) {
    if (category.items.includes(item)) {
      return category.name;
    }
  }
  return undefined;
}

export class MachineTypesRepository {

    constructor() {}

    categories(): MachineTypesCategory[] {
        return machineTypesCategories
    }

    category(name: string): MachineTypesCategory | undefined {
        return machineTypesCategories.find((v) => v.name === name)
    }

}